<template>
<div class="page-wrapper">
	<div class="page page-settings">
		<div class="container">
			<div class="page-header">
				<h1 class="page-title">
					<router-link class="text" to="/settings">Settings</router-link>
					<i class="separator material-icons">chevron_right</i>
					<span class="page-breadcrumb">WhatsApp Gateway</span>
				</h1>
			</div>
			<div class="page-content">
				<div class="box p-0">
					<!-- Waboxapp -->
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<img src="/images/logo-small-waboxapp.png" alt="Waboxapp">
								</div>
								<button type="button" class="integration-app-button btn btn-primary" v-if="waboxappAccounts.length === 0" @click="isShowModalWaboxapp = true">+ Add Waboxapp Account</button>
							</div>
						</div>
						<integration-accounts
							:name="'Waboxapp Account'"
							:editable="true"
							:accounts="waboxappAccounts"
							@remove="removeIntegration"
							@edit="editWaboxapp">
						</integration-accounts>
					</div>

					<!-- Woowa -->
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<img src="https://orderonline.s3-ap-southeast-1.amazonaws.com/img/logo-woowa-new.png" alt="Woowa">
								</div>
								<button type="button" class="integration-app-button btn btn-primary" @click="showModalAddWoowa">+ Add Woowa Account</button>
							</div>
						</div>
						<integration-accounts
							:name="'Woowa Account'"
							:editable="true"
							:accounts="woowaAccounts"
							@remove="removeIntegration"
							@edit="editWoowa">
						</integration-accounts>
					</div>

					<!-- Wonotif -->
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<img src="https://orderonline.s3-ap-southeast-1.amazonaws.com/img/logo-woonotiff.png" alt="Woonotif">
								</div>
								<button type="button" class="integration-app-button btn btn-primary" @click="showModalAddWooNotif">+ Add Woonotif Account</button>
							</div>
						</div>
						<integration-accounts
							:name="'Woonotif Account'"
							:editable="true"
							:accounts="woonotifAccounts"
							@remove="removeIntegration"
							@edit="editWonotif">
						</integration-accounts>
					</div>

				</div>
			</div>
		</div>
	</div>
	<div class="modals">
		<!-- Waboxapp -->
		<modal class="integration-modal" :size="'large'" v-if="isShowModalWaboxapp" @close="isShowModalWaboxapp = false">
			<div slot="header"><h3>Waboxapp</h3></div>
			<div slot="body" class="row">
				<!-- TUTORIAL -->
				<div class="col-md-6">
					<h4 class="modal-title">How to Integrate</h4>
					<div class="integration-video embed-responsive embed-responsive-16by9">
						<iframe src="https://www.youtube.com/embed/Rv2zM-R5wn0?rel=0"></iframe>
					</div>
				</div>
				<!-- CONFIG -->
				<div class="col-md-6">
					<h4 class="modal-title">Configurations</h4>
					<div class="integration-actions">
						<div class="form-group">
							<input type="text" class="input form-control" placeholder="Waboxapp API Token" v-model="waboxappApiToken">
						</div>
						<div class="form-group">
							<input type="text" class="input form-control" placeholder="Waboxapp Default WhatsApp Number (6281123456789)" v-model="waboxappPhone">
						</div>
						<div class="text-right">
							<button
								v-if="waboxappActionType === 'add'"
								type="button"
								class="btn btn-primary"
								:class="{ 'is-loading': isAddingWaboxapp }"
								:disabled="waboxappApiToken.length === 0 || waboxappPhone.length === 0"
								@click="addWaboxapp">Integrate
							</button>
							<button
								v-else
								type="button"
								class="btn btn-primary"
								:class="{ 'is-loading': isAddingWaboxapp }"
								:disabled="waboxappApiToken.length === 0 || waboxappPhone.length === 0"
								@click="updateWaboxapp">Update
							</button>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button class="btn btn-light" @click="isShowModalWaboxapp = false">{{ $t('Close') }}</button>
			</div>
		</modal>

		<!-- Woowa -->
		<modal class="integration-modal" :size="'large'" v-if="isShowModalWoowa" @close="isShowModalWoowa = false">
			<div slot="header"><h3>Woowa</h3></div>
			<div slot="body" class="row">
				<!-- TUTORIAL -->
				<div class="col-md-6">
					<h4 class="modal-title">How to Integrate</h4>
					<div class="integration-video embed-responsive embed-responsive-16by9">
						<!-- <iframe src="https://www.youtube.com/embed/qyjmyT4bZEA?rel=0"></iframe> -->
						<iframe src="https://www.youtube.com/embed/UcEpm6tdOhA?rel=0"></iframe>
					</div>
				</div>

				<!-- CONFIG -->
				<div class="col-md-6">
					<h4 class="modal-title">Configurations</h4>
					<div class="integration-actions">
						<!-- Status -->
						<div class="form-group hidden">
							<!-- <label><b>Account Type</b><i class="material-icons info" v-tooltip="'<div class=\'order-status-tooltip text-left\'><div><b>Disabled</b>: Halaman pemesanan produk tidak dapat dikunjungi</div><div><b>Test Mode</b>: Halaman pemesanan produk dapat dikunjungi tetapi order yang terjadi tidak akan diproses</div><div><b>Live</b>: Halaman pemesanan produk siap untuk digunakan</div></div>'">info</i></label> -->
							<div class="btn-group btn-group-toggle btn-group-block" role="group">
								<button type="button" class="btn btn-default col" :class="{ 'active': woowaAccountType === 'eco' }" @click="changeWoowaAccountType('eco')">Eco</button>
								<button type="button" class="btn btn-default col" :class="{ 'active': woowaAccountType === 'premium' }" @click="changeWoowaAccountType('premium')">Premium</button>
							</div>
						</div>

						<!-- account type premium -->
						<template v-if="woowaAccountType === 'premium'">
							<div class="form-group">
								<!-- <label for="">License</label> -->
								<input type="text" class="input form-control" placeholder="Woowa License" v-model="woowaLicense">
							</div>
							<div class="form-group">
								<!-- <label for="">Domain</label> -->
								<input type="text" class="input form-control" placeholder="Domain" v-model="woowaDomain">
							</div>
						</template>

						<!-- account type eco -->
						<template v-else>
							<div class="form-group hidden">
								<!-- <label for="">License</label> -->
								<input type="text" class="input form-control" placeholder="Woowa IP" v-model="woowaIp">
							</div>
							<div class="form-group">
								<!-- <label for="">Domain</label> -->
								<input type="text" class="input form-control" placeholder="Key" v-model="woowaKey">
							</div>
						</template>

						<div class="form-group">
							<!-- <label for="">WhatsApp Number</label> -->
							<input type="text" class="input form-control" placeholder="Woowa Default WhatsApp Number (6281123456789)" v-model="woowaPhone">
						</div>
						<div class="text-right">
							<button
								v-if="woowaActionType === 'add'"
								type="button"
								class="btn btn-primary"
								:class="{ 'is-loading': isAddingWoowa }"
								:disabled="woowaNotValid"
								@click="addWoowa">Integrate
							</button>
							<button
								v-else
								type="button"
								class="btn btn-primary"
								:class="{ 'is-loading': isAddingWoowa }"
								:disabled="woowaNotValid"
								@click="updateWoowa">Update
							</button>
						</div>
					</div>
				</div>

			</div>
			<div slot="footer">
				<button class="btn btn-light" @click="isShowModalWoowa = false">{{ $t('Close') }}</button>
			</div>
		</modal>

		<!-- Woonotif -->
		<modal class="integration-modal" :size="'large'" v-if="isShowModalWoonotif" @close="isShowModalWoonotif = false">
			<div slot="header"><h3>Woonotif</h3></div>
			<div slot="body" class="row">
				<!-- TUTORIAL -->
				<div class="col-md-6">
					<h4 class="modal-title">How to Integrate</h4>
					<div class="integration-video embed-responsive embed-responsive-16by9">
						<iframe src="https://www.youtube.com/embed/tuCJSwijEKs?rel=0"></iframe>
					</div>
				</div>

				<!-- CONFIG -->
				<div class="col-md-6">
					<h4 class="modal-title">Configurations</h4>
					<div class="integration-actions">
						<!-- <div class="form-group">
							<input type="text" class="input form-control" placeholder="Container IP" v-model="woonotifIp">
						</div> -->
						<div class="form-group">
							<input type="text" class="input form-control" placeholder="Token Key" v-model="woonotifToken">
						</div>
						<div class="form-group">
							<input type="text" class="input form-control" placeholder="Woonotif WhatsApp Number (6281123456789)" v-model="woonotifPhone">
						</div>
						<div class="text-right">
							<button
								v-if="woonotifActionType === 'add'"
								type="button"
								class="btn btn-primary"
								:class="{ 'is-loading': isAddingWoonotif }"
								:disabled="!isWoonotifValid"
								@click="addWoonotif">Integrate
							</button>
							<button
								v-else
								type="button"
								class="btn btn-primary"
								:class="{ 'is-loading': isAddingWoonotif }"
								:disabled="!isWoonotifValid"
								@click="updateWoonotif">Update
							</button>
						</div>
					</div>
				</div>

			</div>
			<div slot="footer">
				<button class="btn btn-light" @click="isShowModalWoonotif = false">{{ $t('Close') }}</button>
			</div>
		</modal>
	</div>

	<notifications group="wa" position="bottom right" />
</div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';
import Modal from '../components/Modal.vue';
import IntegrationAccounts from '../components/IntegrationAccounts.vue';
import integrationApi from '../api/integration';

export default {
	name: 'settingsWhatsApp',
	components: {
		Modal,
		IntegrationAccounts,
	},
	data() {
		return {
			waboxappApiToken: '',
			waboxappPhone: '',
			woowaLicense: '',
			woowaDomain: '',
			woowaPhone: '',
			woowaIp: '',
			woowaKey: '',
			woowaAccountType: 'eco',
			woonotifIp: '',
			woonotifToken: '',
			woonotifPhone: '',
			isShowModalWaboxapp: false,
			isShowModalWoowa: false,
			isAddingWaboxapp: false,
			isAddingWoowa: false,
			isShowModalWoonotif: false,
			isAddingWoonotif: false,
			waboxappActionType: 'add',
			woowaActionType: 'add',
			woonotifActionType: 'add',
			integrationId: '',
		};
	},
	methods: {
		...mapActions({
			fetchAccounts: 'settings/fetchAccounts',
			addAccount: 'settings/addAccount',
			removeAccount: 'settings/removeAccount',
			updateAccount: 'settings/updateAccount',
		}),
		removeIntegration(id) {
			this.removeAccount(id);
			const callback = (response) => {
				// console.log(response);
			};
			integrationApi.remove(id, callback);
		},
		addWaboxapp() {
			this.isAddingWaboxapp = true;

			const waboxappApiToken = this.waboxappApiToken;
			const waboxappPhone = this.waboxappPhone;

			const params = {
				api_token: waboxappApiToken,
				phone_number: waboxappPhone,
			};
			const callback = (response) => {
				const account = response.data;
				if (account !== '') {
					this.addAccount(account);
				}
				this.isAddingWaboxapp = false;
				this.isShowModalWaboxapp = false;
				this.waboxappActionType = 'add';

				this.$notify({
					group: 'wa',
					title: 'Waboxapp',
					text: 'Successfully Connected to Waboxapp',
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				if (e.response) {
					const response = e.response.data;
					const errorMessage = response.message;
					this.$notify({
						group: 'wa',
						title: 'Waboxapp',
						text: errorMessage,
						type: 'error',
					});
				}
				this.isAddingWaboxapp = false;
			};
			integrationApi.addWaboxapp(params, callback, errorCallback);
		},
		addWoowa() {
			this.isAddingWoowa = true;

			const params = {
				phone_number: parseInt(this.woowaPhone),
				account_type: this.woowaAccountType,
			};

			if (this.woowaAccountType === 'premium') {
				params.license = this.woowaLicense;
				params.domain = this.woowaDomain;
			} else if (this.woowaAccountType === 'eco') {
				params.ip = this.woowaIp;
				params.key = this.woowaKey;
			}

			const callback = (response) => {
				const account = response.data;
				if (account !== '') {
					this.addAccount(account);
				}
				this.isAddingWoowa = false;
				this.isShowModalWoowa = false;
				this.woowaActionType = 'add';

				// clear fields
				this.woowaLicense = '';
				this.woowaDomain = '';
				this.woowaPhone = '';

				this.$notify({
					group: 'wa',
					title: 'Woowa',
					text: 'Successfully Connected to Woowa',
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				if (e.response) {
					const response = e.response.data;
					const errorMessage = response.message;
					this.$notify({
						group: 'wa',
						title: 'Woowa',
						text: errorMessage,
						type: 'error',
					});
				}
				this.isAddingWoowa = false;
			};
			integrationApi.addWoowa(params, callback, errorCallback);
		},
		addWoonotif() {
			this.isAddingWoonotif = true;

			const container_ip = this.woonotifIp;
			const token = this.woonotifToken;
			const phone_number = parseInt(this.woonotifPhone);

			const params = { container_ip, token, phone_number };
			const callback = (response) => {
				const account = response.data;
				if (account !== '') {
					this.addAccount(account);
				}
				this.isAddingWoonotif = false;
				this.isShowModalWoonotif = false;
				this.wonotifActionType = 'add';

				// clear fields
				this.woonotifIp = '';
				this.woonotifToken = '';
				this.woonotifPhone = '';

				this.$notify({
					group: 'wa',
					title: 'Woonotif',
					text: 'Successfully Connected to Woonotif',
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				if (e.response) {
					const response = e.response.data;
					const errorMessage = response.message;
					this.$notify({
						group: 'wa',
						title: 'Woonotif',
						text: errorMessage,
						type: 'error',
					});
				}
				this.isAddingWoonotif = false;
			};
			integrationApi.addWoonotif(params, callback, errorCallback);
		},
		editWaboxapp(accountId) {
			this.isShowModalWaboxapp = true;
			this.waboxappActionType = 'edit';
			this.integrationId = accountId;
			const waboxapp = this.accounts.find(curr => curr._id === accountId);
			// set value on form
			this.waboxappApiToken = waboxapp.data.api_token;
			this.waboxappPhone = waboxapp.data.phone_number;
		},
		editWoowa(accountId) {
			this.isShowModalWoowa = true;
			this.woowaActionType = 'edit';
			this.integrationId = accountId;
			const woowa = this.accounts.find(curr => curr._id === accountId);

			// set value on form
			this.woowaAccountType = woowa.data.account_type;
				this.woowaPhone = woowa.data.phone_number;
			if (this.woowaAccountType === 'premium') {
				this.woowaLicense = woowa.data.license;
				this.woowaDomain = woowa.data.domain;
			} else if (this.woowaAccountType === 'eco') {
				this.woowaIp = woowa.data.ip;
				this.woowaKey = woowa.data.key;
			}
		},
		editWonotif(accountId) {
			this.isShowModalWoonotif = true;
			this.woonotifActionType = 'edit';
			this.integrationId = accountId;
			const woonotif = this.accounts.find(curr => curr._id === accountId);

			// set value on form
			this.woonotifIp = woonotif.data.container_ip;
			this.woonotifToken = woonotif.data.token;
			this.woonotifPhone = woonotif.data.phone_number;
		},
		updateWaboxapp() {
			this.isAddingWaboxapp = true;

			const integrationId = this.integrationId;
			const waboxappApiToken = this.waboxappApiToken;
			const waboxappPhone = this.waboxappPhone;

			const params = {
				api_token: waboxappApiToken,
				phone_number: waboxappPhone,
			};
			const callback = (response) => {
				const account = response.data;
				if (account !== '') {
					this.updateAccount(account);
				}

				this.isAddingWaboxapp = false;
				this.isShowModalWaboxapp = false;
				this.waboxappActionType = 'add';
				this.integrationId = '';

				this.$notify({
					group: 'wa',
					title: 'Waboxapp',
					text: 'Successfully Updated to Waboxapp',
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				if (e.response) {
					const response = e.response.data;
					const errorMessage = response.message;
					this.$notify({
						group: 'wa',
						title: 'Waboxapp',
						text: errorMessage,
						type: 'error',
					});
				}
				this.isAddingWaboxapp = false;
				// this.isShowModalWaboxapp = false;
				// this.waboxappActionType = 'add';
				// this.integrationId = '';
			};
			integrationApi.updateWaboxapp(integrationId, params, callback, errorCallback);
		},
		updateWoowa() {
			this.isAddingWoowa = true;
			const integrationId = this.integrationId;
			const params = {
				phone_number: parseInt(this.woowaPhone),
				account_type: this.woowaAccountType,
			};

			if (this.woowaAccountType === 'premium') {
				params.license = this.woowaLicense;
				params.domain = this.woowaDomain;
			} else if (this.woowaAccountType === 'eco') {
				params.ip = this.woowaIp;
				params.key = this.woowaKey;
			}

			const callback = (response) => {
				const account = response.data;
				if (account !== '') {
					this.updateAccount(account);
				}
				this.isAddingWoowa = false;
				this.isShowModalWoowa = false;
				this.woowaActionType = 'add';
				this.integrationId = '';

				// clear fields
				this.woowaLicense = '';
				this.woowaDomain = '';
				this.woowaPhone = '';

				this.$notify({
					group: 'wa',
					title: 'Woowa',
					text: 'Successfully Connected to Woowa',
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				if (e.response) {
					const response = e.response.data;
					const errorMessage = response.message;
					this.$notify({
						group: 'wa',
						title: 'Woowa',
						text: errorMessage,
						type: 'error',
					});
				}
				this.isAddingWoowa = false;
				// this.isShowModalWoowa = false;
				// this.woowaActionType = 'add';
				// this.integrationId = '';
			};
			integrationApi.updateWoowa(integrationId, params, callback, errorCallback);
		},
		updateWoonotif() {
			this.isAddingWoonotif = true;
			const integrationId = this.integrationId;
			const container_ip = this.woonotifIp;
			const token = this.woonotifToken;
			const phone_number = parseInt(this.woonotifPhone);

			const params = { container_ip, token, phone_number };
			const callback = (response) => {
				const account = response.data;
				if (account !== '') {
					this.updateAccount(account);
				}
				this.isAddingWoonotif = false;
				this.isShowModalWoonotif = false;
				this.wonotifActionType = 'add';
				this.integrationId = '';

				// clear fields
				this.woonotifIp = '';
				this.woonotifToken = '';
				this.woonotifPhone = '';

				this.$notify({
					group: 'wa',
					title: 'Woonotif',
					text: 'Successfully Connected to Woonotif',
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				if (e.response) {
					const response = e.response.data;
					const errorMessage = response.message;
					this.$notify({
						group: 'wa',
						title: 'Woonotif',
						text: errorMessage,
						type: 'error',
					});
				}
				this.isAddingWoonotif = false;
				// this.isShowModalWoonotif = false;
				// this.wonotifActionType = 'add';
				// this.integrationId = '';
			};
			integrationApi.updateWoonotif(integrationId, params, callback, errorCallback);
		},
		changeWoowaAccountType(type) {
			this.woowaAccountType = type;
		},
		showModalAddWoowa() {
			this.woowaActionType = 'add';
			this.woowaLicense = '';
			this.woowaDomain = '';
			this.woowaPhone = '';
			this.isShowModalWoowa = true;
		},
		showModalAddWooNotif() {
			this.woonotifActionType = 'add';
			this.woonotifToken = '';
			this.woonotifIp = '';
			this.woonotifPhone = '';
			this.isShowModalWoonotif = true;
		},
	},
	computed: {
		...mapGetters({
			isFetching: 'settings/isFetching',
			accounts: 'settings/accounts',
		}),
		waboxappAccounts() {
			return this.accounts.filter(account => account.name === 'waboxapp');
		},
		woowaAccounts() {
			return this.accounts.filter(account => account.name === 'woowa');
		},
		woonotifAccounts() {
			return this.accounts.filter(account => account.name === 'woonotif');
		},
		woowaNotValid() {
			switch (this.woowaAccountType) {
				case 'premium':
					if (this.woowaLicense.length === 0 || this.woowaDomain.length === 0 || this.woowaPhone.length === 0) {
						return true;
					}
					break;

				case 'eco':
					if ((this.woowaIp && this.woowaIp.length === 0)
						|| (this.woowaKey && this.woowaKey.length === 0)
						|| (this.woowaPhone && this.woowaPhone.length === 0)) {
						return true;
					}
					break;

				default:
					break;
			}

			return false;
		},
		isWoonotifValid() {
			// const ip = this.woonotifIp ? this.woonotifIp.trim() : '';
			const token = this.woonotifToken ? this.woonotifToken.trim() : '';
			const phone = this.woonotifPhone ? this.woonotifPhone.trim() : '';
			return token.length !== 0 && phone.length !== 0;
		},
	},
	created() {
		if (!this.isFetching) {
			this.fetchAccounts({ get_details: true });
		}
	},
};
</script>
